// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n3M71","rootNoMargin":"styles_rootNoMargin__lmyLm"};